import React from "react";
import { Layout } from "src/components/layout/Layout";
import { ModuleRouter } from "src/components/molecules";
import { UnauthorizedRoute } from "./unauthorized.routes";

export function Main() {
  return (
    <Layout>
      {UnauthorizedRoute.subRoutes && (
        <ModuleRouter subRoutes={UnauthorizedRoute.subRoutes} path={UnauthorizedRoute.path} />
      )}
    </Layout>
  );
}
